import React from 'react';
import Axios from 'axios';
import { Tooltip } from 'reactstrap';

// TENBALL version - single and double matchs, victory points
// This component is DIFFERENT since we are splitting stats into different category arrays

// Constants for this standings
const cstTableHeaders = [
	'Rang',	'Équipe',	'MOY', 'SMOY', 'MJ', 'PJ', 'VIC', 'HDCP', 'PTS TOT', 'TP', 'TC', 'TBB', 'Domicile', '#players'];

const cstDefaultSortOrder = [
	'', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', 'asc', 'asc'];

const cstFixedDecimalsStats = [
	{fieldIdx: 2, decimals: 1},
	{fieldIdx: 3, decimals: 1}
];

const cstDefaultSortFieldIdx = 2;
const cstStandTypes = ['Tous', 'Simple', 'Double'];

class TeamStandings_10B extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			sortFieldIdx: cstDefaultSortFieldIdx,
			sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],
			sortStandingIdx: 0,
			standings: [],
			standingsData: [],
			standingIdx: 0,

			tooltipOpen: [false],
		};
	
		this.createSelectItem = this.createSelectItem.bind(this);
		this.standTypeChange = this.standTypeChange.bind(this);
		this.createStandingHdrRow = this.createStandingHdrRow.bind(this);
		this.createStandingRow = this.createStandingRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
		this.toggleTooltip = this.toggleTooltip.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
	}

	componentDidMount() {
		this.initStandings(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.initStandings(nextProps);
	}

	initStandings(props) {
		var standings = props.standings;
		standings = this.processTeamStandings(standings);
		standings = this.createStandingsData(standings);

		var tooltipOpen = new Array(standings[0].results.length).fill(false);

		this.setState({
			standings: standings,
			standingIdx: props.standingIdx,
			tooltipOpen: tooltipOpen,
		});
	}

	processTeamStandings(standings) {

		// expecting at least and only one team standings element
		for (var idx = 0; idx < standings.length; idx++) {
		//if(standings.length === 1) {
			for (var j = 0; j < standings[idx].results.length; j++) {

				// calculate moyennes for single and double stats
				standings[idx].results[j].gamesPlayedTot = 0;
				standings[idx].results[j].gamesWonTot = 0;
				standings[idx].results[j].eroTot = 0;
				standings[idx].results[j].eroContreTot = 0;
				standings[idx].results[j].avg10Bcomp = [];
				standings[idx].results[j].avg10BTot = 0;
				standings[idx].results[j].superMoy10Bcomp = [];
				standings[idx].results[j].superMoy10BTot = 0;

				// Compute single and double moyenne, and total
				for (var k = 0; k < 2; k++) {

					standings[idx].results[j].avg10Bcomp.push(
						(standings[idx].results[j].gamesWon[k] / standings[idx].results[j].gamesPlayed[k] * 100));

					standings[idx].results[j].superMoy10Bcomp.push(
						(standings[idx].results[j].gamesWon[k] + (standings[idx].results[j].ero[k] * 1.25)) / 
						(standings[idx].results[j].gamesPlayed[k] - standings[idx].results[j].eroContre[k]) * 100);

					standings[idx].results[j].gamesPlayedTot += standings[idx].results[j].gamesPlayed[k];
					standings[idx].results[j].gamesWonTot += standings[idx].results[j].gamesWon[k];
					standings[idx].results[j].eroTot += standings[idx].results[j].ero[k];
					standings[idx].results[j].eroContreTot += standings[idx].results[j].eroContre[k];
				}

				standings[idx].results[j].avg10BTot = Math.round(
					((standings[idx].results[j].gamesWonTot + standings[idx].results[j].pointsHandicapFor) / 
						standings[idx].results[j].gamesPlayedTot) * 10000) / 100;

				standings[idx].results[j].superMoy10BTot = Math.round(
					(standings[idx].results[j].gamesWonTot + standings[idx].results[j].pointsHandicapFor + (standings[idx].results[j].eroTot * 1.25)) / 
					(standings[idx].results[j].gamesPlayedTot - standings[idx].results[j].eroContreTot) * 10000) / 100;
			}
		}
		return standings;
	}

	createStandingsData(standings) {
		//console.log('createStandingsData')
		var _this = this;
		var standingsData = [];
		var stdIdx = 0;
		var newStandings = [];

		// Parse standings to get Tot, Sgl, Dbl, Teams for each one
		// Div1 becomes Div1-Tot, Div1-Sgl, Div1-Dbl, Div1-Teams
		// Div2 becomes Div2-Tot, Div2-Sgl, Div2-Dbl, Div2-Teams
		// Div... becomes Div...-Tot, Div...-Sgl, Div...-Dbl, Div...-Teams
		// Gen becomes Gen-Tot, Gen-Sgl, Gen-Dbl, Gen-Teams
		// Subs becomes Subs-Tot, Subs-Sgl, Subs-Dbl, Subs-Teams

		// Parse standings
		standings.forEach(function(standItem, standIdx) {

			var divStandings = [];
			stdIdx = divStandings.length;
			divStandings[stdIdx + 0] = [];
			divStandings[stdIdx + 1] = [];
			divStandings[stdIdx + 2] = [];

			// Stats
			var partiesJouees = 0;
			var victoires = 0;
			var handicap;
			var pointsTotaux;
			var troPour = 0;
			var troContre = 0;
			var tenballBreak = 0;
			var avg10B = 0;
			var superMoy10B = 0;

			// Parse results
			standItem.results.forEach(function(result, resultIdx) {

				for (var idx = 0; idx < 3; idx++) {

					// Check type selected
					switch(idx) {

					// Total
					case 0:
						partiesJouees = result.gamesPlayedTot;
						victoires = result.gamesWon[0] + result.gamesWon[1];
						handicap = result.pointsHandicapFor; 	// or -- ic activeType !== 0
						pointsTotaux = Math.round((result.gamesWon[0] + result.gamesWon[1] + result.pointsHandicapFor) * 100) / 100;
						troPour = result.ero[0] + result.ero[1];
						troContre = result.eroContre[0] + result.eroContre[1];
						tenballBreak = result.tbb[0] + result.tbb[1];
						avg10B = result.avg10BTot;
						superMoy10B = result.superMoy10BTot;
						break;

					// Single
					case 1:
						partiesJouees = result.gamesPlayed[0];
						victoires = result.gamesWon[0];
						handicap = '--';
						pointsTotaux = result.gamesWon[0];
						troPour = result.ero[0];
						troContre = result.eroContre[0];
						tenballBreak = result.tbb[0];
						avg10B = result.avg10Bcomp[0];
						superMoy10B = result.superMoy10Bcomp[0];
						break;

					// Double
					case 2:
						partiesJouees = result.gamesPlayed[1];
						victoires = result.gamesWon[1];
						handicap = '--';
						pointsTotaux = result.gamesWon[1];
						troPour = result.ero[1];
						troContre = result.eroContre[1];
						tenballBreak = result.tbb[1];
						avg10B = result.avg10Bcomp[1];
						superMoy10B = result.superMoy10Bcomp[1];
						break;
					}

					var standingRow = [];
					standingRow.push(0);
					standingRow.push(result.teamName);
					standingRow.push(avg10B);
					standingRow.push(superMoy10B);
					standingRow.push(result.matchsTotal);
					standingRow.push(partiesJouees);
					standingRow.push(victoires);
					standingRow.push(handicap);
					standingRow.push(pointsTotaux);
					standingRow.push(troPour);
					standingRow.push(troContre);
					standingRow.push(tenballBreak);
					standingRow.push(result.homeSite);
					standingRow.push(result.players);

					// Create divStandings
					divStandings[stdIdx + idx].push(standingRow.slice());
				}
			});

			// Build StandingsData multi-dimensionnal array
			divStandings.forEach(function(divStand, divStandIdx) {
				standingsData.push(divStand.slice());

				// Working
				// splitted standings - MUST push individual item values
				newStandings.push({
					order: standItem.order,
					results: standItem.results.slice(),		// values
					showTeam: standItem.showTeam,
					title: standItem.title,
					standType: cstStandTypes[divStandIdx]
				});
			});
		});

		// First data sort
		var sortFieldIdx = cstDefaultSortFieldIdx;
		var sortOrder = cstDefaultSortOrder[cstDefaultSortFieldIdx];

		standingsData.forEach(function (standingsItemData, standingsIdx) {
			_this.sortOneStandingsData(standingsItemData, standingsIdx, sortFieldIdx, sortOrder);
		});
		return newStandings;
	}

	resetAllSorting() {
		var _this = this;
		var standingsData = this.state.standingsData;
		var sortFieldIdx = cstDefaultSortFieldIdx;
		var sortOrder = cstDefaultSortOrder[sortFieldIdx];

		standingsData.forEach(function (standingsItemData, standingsIdx) {
			_this.sortOneStandingsData(standingsItemData, standingsIdx, sortFieldIdx, sortOrder);
		});

		this.setState({
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
		});
	}

	sortOneStandingsData(standingsItemData, standingsIdx, sortFieldIdx, sortOrder) {

		// Manage empty data
		if (standingsItemData.length !== 0) {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			standingsItemData.sort(function(a, b) {

				var valueA = a[sortFieldIdx];
				var valueB = b[sortFieldIdx];
				var compVal = 0;

				switch(typeof a[sortFieldIdx]) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
		        break;
			    case "string":
						compVal = valueA.localeCompare(valueB);
		        break;
			    case "number":
						compVal = valueA - valueB;
		        break;
			    default:
		        break;
				}

				if (compVal !== 0) return (sortSign * compVal);
				return (a[0] - b[0]);
			});
		}

		// Reset Rank column
		if (standingsItemData[0][0] !== "") {
			standingsItemData.forEach(function(row, idx) {
				row[0] = idx + 1;
			});
		}

		var standingsData = this.state.standingsData;
		standingsData[standingsIdx] = standingsItemData;

		this.setState({
			standingsData: standingsData,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
		});
	}

	render() {
		// console.log('STAND 10B: RENDER');
		// console.log(this.state.standings);
		// console.log(this.state.standingsData);
		var standings = this.state.standings;
		var standingIdx = this.state.standingIdx;

		return (
			<div>
				{(standings.length > 1) ? this.dispStandTypesSelector(standings) : null}
				<br/>
				{(standings.length !== 0) ? this.dispStandings(standings, standingIdx) : null}

				<div className="no-print">
				{this.createLegend()}
				</div>
			</div>
		);
	}

	dispStandTypesSelector(standings) {
		return (
			<div className="row no-print">
			<div className="col-md-4">
				Options de classement
        <select className="form-control" value={this.state.standType} onChange={this.standTypeChange}>
          {standings.map(this.createSelectItem)}
        </select>
			</div>
			</div>
		);
	}

  createSelectItem(standingsItem, standingsIdx) {
    return (
      <option value={standingsIdx} key={"stdType" + standingsIdx}>
      	{standingsItem.title + ' - ' + standingsItem.standType}
      </option>
    );
	}

	standTypeChange(e) {
		//console.log('standTypeChange')
		this.resetAllSorting();
		this.setState({
			standingIdx: e.target.value
		});
		this.props.handleStandingIdxChange(e.target.value);
	}

	dispStandings(standings, standingsIdx) {
		var _this = this;
		var standingsItem = standings[standingsIdx];
		var standingsData = this.state.standingsData;

		return (
			<div className="row">
			<div className="col-md-12" key={'div.' + standingsIdx}>

				{/* NO-PRINT SECTION */}
				<div className="card no-print">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						{standingsItem.title.toUpperCase() + ' - ' + standingsItem.standType.toUpperCase()}
					</div>

					<div className="card-body card-block">
						<div className="table-responsive tableFixHeader resizeVerticalStandings">
							<table className="table table-striped table-hover table-sm tableFix2col">
							<thead>
							<tr>
								{cstTableHeaders.map(function(elem, idx) {
									return _this.createStandingHdrRow(standingsIdx, elem, idx)
								})}
							</tr>
							</thead>
							<tbody>
								{(standingsData[standingsIdx].length !== 0) ?
									standingsData[standingsIdx].map(this.createStandingRow.bind(this, standingsIdx, true)) :
									<tr><td colSpan="99">(Aucune donnée)</td></tr>
								}
							</tbody>
							</table>
						</div>
					</div>
				</div>

				{/* PRINT-ONLY SECTION*/}
				<div className="print-only">
					<h5>{standingsItem.title.toUpperCase() + ' - ' + standingsItem.standType.toUpperCase()}</h5>
					<div className="table-responsive print-container">
						<table className="table table-striped table-sm">
						<thead>
						<tr>
							{cstTableHeaders.map(function(elem, idx) {
								return _this.createStandingHdrRow(standingsIdx, elem, idx)
							})}
						</tr>
						</thead>
						<tbody>
								{(standingsData[standingsIdx].length !== 0) ?
									standingsData[standingsIdx].map(this.createStandingRow.bind(this, standingsIdx, false)) :
									<tr><td colSpan="99">(Aucune donnée)</td></tr>
								}
						</tbody>
						</table>
					</div>
				</div>

	    </div>
	    </div>
		);
	}

	createStandingHdrRow(standingsIdx, hdrItem, hdrIdx) {
		var classNameStr = '';
		var onClickAction = function() {};

		if (hdrItem !== '#players') {

			// No header if no team (subs)
			if((this.state.standings[standingsIdx].showTeam === false) && (hdrIdx === cstTeamFieldIdx)) {
				hdrItem = '';
			}

			// Sort with arrows
			// No sort on Rank (column 0)
			if (hdrIdx !== 0) {
				onClickAction = this.handleSortTable;
				classNameStr = 'statelo-sorting';
				if(hdrIdx === this.state.sortFieldIdx) {
					if (this.state.sortOrder === "asc") {
						classNameStr += ' statelo-sorting_asc';
					} else {
						classNameStr += ' statelo-sorting_desc';
					}
				}
			}
			
			return (
				<th key={"colid." + standingsIdx + '.' + hdrIdx} 
					id={"colid." + standingsIdx + '.' + hdrIdx} 
					className={classNameStr}
					onClick={onClickAction}>
					{hdrItem}
				</th>
			);
		}
	}

	createStandingRow(standingsIdx, withTooltips, tableDataRow, tableDataRowIdx) {

		if (withTooltips) {
			var playerscolIdx = cstTableHeaders.findIndex((elem) => (elem === '#players'));
			var teamPlayers = tableDataRow[playerscolIdx];

			teamPlayers = teamPlayers.sort((a, b) => (a.fullnameB.localeCompare(b.fullnameB)));

			return (
				<tr key={'tr.' + tableDataRowIdx} className="stateloListItemPointer">

					{tableDataRow.slice(0, 1).map(this.createDataCell.bind(this, tableDataRowIdx, 0, 0))}
	  			{tableDataRow.slice(1, 2).map(this.createDataCell.bind(this, tableDataRowIdx, 1, 1))}
					{tableDataRow.slice(2).map(this.createDataCell.bind(this, tableDataRowIdx, 2, 0))}
	 
		 			{/* Tooltip */}
				  <Tooltip placement="right" 
				  	target={'tooltipCell-' + tableDataRowIdx} toggle={() => {this.toggleTooltip(tableDataRowIdx)}}
				  	isOpen={this.state.tooltipOpen[tableDataRowIdx]} autohide={false}>
	    			
	  				<strong key={'tpnt.' + standingsIdx + '.' + tableDataRowIdx}> 
	  					{tableDataRow[1]}<br/> 
	  				</strong>
	    			{teamPlayers.map((tpn, tpnidx) => 
	    				(<span key={'tpn.' + standingsIdx + '.' + tableDataRowIdx + '.' + tpnidx}> 
	    					{tpn.fullnameB} [{tpn.ratingsStr}]<br/> 
	    					</span>))}

				  </Tooltip>
		    </tr>
	    );

		} else {

			return (
				<tr key={'tr.' + tableDataRowIdx} className="stateloListItemPointer">
					{tableDataRow.map(this.createDataCell.bind(this, tableDataRowIdx, 0, 0))}
		    </tr>
	    );			
		}
	}

	createDataCell(tableDataRowIdx, colOffset, tooltipOption, dataCell, dataCellIdx) {

		// offset column idx according to starting point
		dataCellIdx += colOffset;

		// Fixed number of decimals, converting to string, for averages or any other stats
		cstFixedDecimalsStats.forEach(function(fdItem, fdIOdx) {
			if (dataCellIdx === fdItem.fieldIdx) {
				dataCell = dataCell.toFixed(fdItem.decimals);
			}
		})

		if (cstTableHeaders[dataCellIdx] !== '#players') {

			// show tooltip only for teams in no-print version of standings to avoid bug with autohide
			if (tooltipOption === 1) {
				return (
					<td key={"tdcell." + tableDataRowIdx + '.' + dataCellIdx}>
						<span id={"tooltipCell-" + tableDataRowIdx}>
							{dataCell}
						</span>
					</td>
				);
			} else {
				return (
					<td key={"tdcell." + tableDataRowIdx + '.' + dataCellIdx}>
						{dataCell}
					</td>
				);
			}
		}
	}
  
  toggleTooltip(i) {
  	//console.log('toggleTooltip: ' + i)
    const newArray = this.state.tooltipOpen.map((element, index) => {
      return (index === i ? !element : false);
    });
    this.setState({
      tooltipOpen: newArray
    });
  }

	/* https://stackoverflow.com/questions/29810914/react-js-onclick-cant-pass-value-to-method */ 
	handleSortTable(e) {

		var _this = this;
		var standingsIdx = parseInt(e.target.id.split(".")[1], 10);
		var sortFieldIdx = parseInt(e.target.id.split(".")[2], 10);

		var standingsData = this.state.standingsData;
		var sortOrder = this.state.sortOrder;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[sortFieldIdx];
		}

		this.setState({
			sortOrder: sortOrder,
			sortFieldIdx: sortFieldIdx,
		});

		this.sortOneStandingsData(standingsData[standingsIdx], standingsIdx, sortFieldIdx, sortOrder);
	}

	createLegend() {
		return (
			<div className="row">
			<div className="col-md-8 col-xs-12">
				<div className="card">
					<div className="card-header">
					<i className="fa fa-th-large"></i>
						LÉGENDE
					</div>

				<div className="card-block">
				<table className="table table-striped table-sm">
				<tbody>
				<tr key='leg1'>
					<td><b>MOY</b></td>
					<td>Moyenne (%)</td>
					<td><b>HDCP</b></td>
					<td>Points de handicap</td>
				</tr>
				<tr key='leg2'>
					<td><b>SMOY</b></td>
					<td>Super moyenne</td>
					<td><b>PTS TOT</b></td>
					<td>Points totaux</td>
				</tr>
				<tr key='leg3'>
					<td><b>MJ</b></td>
					<td>Matchs joués</td>
					<td><b>TP</b></td>
					<td>TRO pour</td>
				</tr>
				<tr key='leg4'>
					<td><b>PJ</b></td>
					<td>Parties jouées</td>
					<td><b>TC</b></td>
					<td>TRO contre</td>
				</tr>
				<tr key='leg5'>
					<td><b>VIC</b></td>
					<td>Victoires</td>
					<td><b>TBB</b></td>
					<td>TenBall breaks</td>
				</tr>
					
				</tbody>
				</table>
				</div>
				</div>
			</div>

			{this.showPrintButton()}
			</div>
		);
	}

	showPrintButton() {
		return (
			<div className="col-md-4 no-print">
				<button className="btn btn-secondary btn-sm btn-fluid pull-right" 
					onClick={this.printTable}> <i className="fa fa-print"></i>&nbsp;&nbsp;Imprimer le classement </button>

				<br/><br/>
				<div className="pull-right">
					<input type="checkbox" onChange={this.props.togglePrintLeagueMsg} checked={this.props.printLeagueMsg || false} />
					&nbsp;&nbsp;Imprimer le message de ligue
				</div>

			</div>
		)
	}

	printTable() {
		// replaceState remplace le URL affiché sur le printout
		var curURL = window.location.href;
		window.history.replaceState(history.state, '', '/');
		window.print();
		window.history.replaceState(history.state, '', curURL);
	}

}

export default TeamStandings_10B;